import axios from 'axios';

const API_URL = 'https://api.paragaia.tn';

const getToken = () => localStorage.getItem('access_token');

// Create a new order from the full cart
export const createCommandeFromCart = async (commandeData) => {
  const token = getToken();
  if (!token) return null;

  try {
    const response = await axios.post(`${API_URL}/commande`, commandeData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error('Error creating commande from cart:', error);
    return null;
  }
};

// Create a new order from selected items only
export const createCommandeFromSelectedItems = async (commandeData) => {
  const token = getToken();
  if (!token) return null;

  try {
    const response = await axios.post(`${API_URL}/commande/from-selected`, commandeData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error('Error creating commande from selected items:', error);
    return null;
  }
};

// Get all commandes of the current user
export const fetchMyCommandes = async () => {
  const token = getToken();
  if (!token) return [];

  try {
    const response = await axios.get(`${API_URL}/commande/mine`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user commandes:', error);
    return [];
  }
};

// Get current user's cart
export const fetchMyCart = async () => {
  const token = getToken();
  if (!token) return null;

  try {
    const response = await axios.get(`${API_URL}/commande/my-cart`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching cart:', error);
    return null;
  }
};
